
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.44608 15.7443L0.924882 15.2202C0.762111 15.0552 0.672439 14.8358 0.672439 14.6012C0.672439 14.3668 0.762111 14.1471 0.924882 13.9822L6.82961 8.00358L0.91833 2.0181C0.755559 1.85341 0.666016 1.6337 0.666016 1.3993C0.666016 1.16489 0.755559 0.945048 0.91833 0.780234L1.43632 0.256002C1.77317 -0.085334 2.32186 -0.085334 2.65871 0.256002L9.72211 7.38243C9.88475 7.54712 9.99935 7.76657 9.99935 8.00306V8.00579C9.99935 8.24033 9.88462 8.45978 9.72211 8.62446L2.67785 15.7443C2.51521 15.9092 2.29193 15.9997 2.06043 16C1.8288 16 1.6086 15.9092 1.44608 15.7443Z","fill":"#383838"}})])
          )
        }
      }
    